// extracted by mini-css-extract-plugin
export default {"getEmailPage":"td_Eew"};